var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkhubIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.0 64.0",
    width: 64,
    height: 64,
    role: "img",
    "aria-label": "WorkHub Manager",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WorkHub Manager") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i-g",
    gradientUnits: "userSpaceOnUse",
    x1: 12,
    y1: 45,
    x2: 54,
    y2: 15
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63c8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19b87a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i-t",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131a33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#16244a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e4f66"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 15,
    fill: "url(#i-t)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 14.5,
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.08,
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) scale(1.0)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "12,24 21.5,45.5 32,31 42.5,45.5 53.5,15.5",
    fill: "none",
    stroke: "url(#i-g)",
    strokeWidth: 7.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18.5,
    r: 5,
    fill: "url(#i-g)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkhubIcon);
export default __webpack_public_path__ + "static/media/workhub-icon.3aa018ced4e5c50e4ecead8c66598a42.svg";
export { ForwardRef as ReactComponent };